import { RefundStatus } from '@nemuru-eng/js-api-client';
import React from 'react';

import { StatusTagType } from '../../../../../config/types';
import { StatusTag } from '../StatusTag';

export const RefundStatusTag: React.FC<{ status: RefundStatus }> = ({ status }) => {
  const getStatusTagProps = (): React.ComponentProps<typeof StatusTag> => {
    switch (status) {
      case RefundStatus.APPROVED:
        return {
          type: StatusTagType.SUCCESS,
          labelTextId: 'APPROVED',
          colorType: 'dark',
        };
      case RefundStatus.PENDING:
        return {
          type: StatusTagType.INFO,
          labelTextId: 'PENDING',
          colorType: 'dark',
        };
      case RefundStatus.CONFIRMED:
        return {
          type: StatusTagType.SUCCESS,
          labelTextId: 'CONFIRMED',
        };
      case RefundStatus.REJECTED:
        return {
          type: StatusTagType.ERROR,
          labelTextId: 'REJECTED',
        };
      case RefundStatus.READY_TO_PROCESS:
        return {
          type: StatusTagType.INFO,
          labelTextId: 'READY_TO_PROCESS',
        };
    }
  };

  const statusTagProps = getStatusTagProps();
  return <StatusTag {...statusTagProps}/>;
};
